import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNewLayoutOptions = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNewLayoutOptions);
};
